import React, { Component } from "react";

import { NavigationWrapper, LinksWrapper, MyLink } from "./Navigation.style";

export class Navigation extends Component {
  render() {
    const { match, links } = this.props;
    return (
      <NavigationWrapper admin = {this.props.admin}>
        <LinksWrapper admin = {this.props.admin}>
          {links.map(link => (
            <MyLink
              lang={this.props.value}
              key={link.name}
              to={`${match.url}/${link.name}`}
              isDefaultRoute={
                match.isExact && link.name === links[0].name ? true : false
              }
            >
              {link.text}
            </MyLink>
          ))}
        </LinksWrapper>
      </NavigationWrapper>
    );
  }
}
